import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-audio-not-published',
  templateUrl: './audio-not-published.component.html',
  styleUrls: ['./audio-not-published.component.scss']
})
export class AudioNotPublishedComponent implements OnInit {
  @Input() public message;
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  closeDialog() {
    this.activeModal.close();
  }
}
